import { fmtDateTime, humanize, personName } from '../vmsConstants';

// The "export" endpoint answers with JSON, not a file — a flat array capped at
// 10 000 rows — so the file is assembled here.

export const EXPORT_ROW_CAP = 10000;

const COLUMNS = [
    ['Logged at', r => fmtDateTime(r.created_at)],
    ['Activity', r => humanize(r.activity_type)],
    ['Description', r => r.description || ''],
    ['Visitor', r => r.visitor?.name || ''],
    ['Visitor phone', r => r.visitor?.phone || ''],
    ['Visit code', r => r.visit?.visit_code || ''],
    ['Visit status', r => (r.visit?.status ? humanize(r.visit.status) : '')],
    // actor_role is a column on the table but is never populated on write, so
    // it is left out rather than exported as a column of blanks.
    ['Actor', r => (r.actor ? personName(r.actor) : '')],
    ['IP address', r => r.ip_address || ''],
    ['Activity ID', r => r.activity_id],
];

// Excel reads a leading =, +, - or @ as a formula, so those cells are prefixed
// with a quote. Quotes are doubled and every field is wrapped, which also
// covers embedded commas and newlines.
const csvCell = (value) => {
    const s = value === null || value === undefined ? '' : String(value);
    const safe = /^[=+\-@]/.test(s) ? `'${s}` : s;
    return `"${safe.replace(/"/g, '""')}"`;
};

export const buildActivityCsv = (rows) => {
    const header = COLUMNS.map(([name]) => csvCell(name)).join(',');
    const body = (rows || []).map(row =>
        COLUMNS.map(([, get]) => csvCell(get(row))).join(',')
    );
    // A BOM so Excel opens UTF-8 names correctly rather than as mojibake.
    return `﻿${[header, ...body].join('\r\n')}`;
};

export const downloadCsv = (filename, csv) => {
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
